import { useContext } from "react"

import AppStateContext from "../components/AppContent/AppStateContext"
import TrackingContext from "../components/DataTracking/trackingContext"

export const useDataTracking = () => {
  const dataTrack = useContext(TrackingContext)
  const appState = useContext(AppStateContext)
  return {
    ...dataTrack,
    ...appState,
  }
}
